// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.archived-training-page{margin:2rem}.archived-training-page h3 i{font-size:2rem}`, "",{"version":3,"sources":["webpack://./src/Pages/ArchivedTrainingPage/ArchivedTrainingPage.style.scss"],"names":[],"mappings":"AAAA,wBACE,WAAA,CAEA,6BACE,cAAA","sourcesContent":[".archived-training-page {\n  margin: 2rem;\n\n  & h3 i {\n    font-size: 2rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
